import { defineComponent as _defineComponent } from 'vue'
import { computed as _computed } from 'vue';

import { VIcon } from 'vuetify/lib';

export type IconSize = 'x-small' | 'small' | 'default' | 'large' | 'x-large';

interface IconProps {
  icon: string;
  size?: IconSize;
  color?: string;
  alt?: string
}

export default /*#__PURE__*/_defineComponent({
  __name: 'SIcon',
  props: {
  icon: null,
  size: { default: 'default' },
  color: null,
  alt: null
},
  setup(__props) {

const props = __props;
const IMAGE_EXTENSIONS = ['jpg', 'jpeg', 'png', 'svg', 'webp'];
const SIZES_IN_PIXEL: Record<IconSize, number> = {
  'x-small': 12,
  small: 16,
  default: 20,
  large: 24,
  'x-large': 32,
};



const sizeInPixel = _computed(() => SIZES_IN_PIXEL[props.size]);
const isImage = _computed(() => {
  const imageExtension = props.icon.split('.').pop();

  return (imageExtension && IMAGE_EXTENSIONS.includes(imageExtension)) || props.icon.startsWith('http');
});

return { __sfc: true,IMAGE_EXTENSIONS, SIZES_IN_PIXEL, props, sizeInPixel, isImage, _computed, VIcon }
}

})